import { type PropsWithChildren } from 'react'
import { type WidgetConfig, LiFiWidget } from '@lifi/widget'
import { SUPPORTED_CHAINS } from '@/config/chain/constants'
import { Loader2 } from 'lucide-react'
import { useHydrated } from '@/ui/utils/useHydrated'

interface ClientOnlyProps extends PropsWithChildren {
  fallback?: React.ReactNode
}

/**
 * Render the children only after the JS has loaded client-side. Use an optional
 * fallback component if the JS is not yet loaded.
 */
export function ClientOnly({ children, fallback = null }: ClientOnlyProps) {
  const hydrated = useHydrated()
  return hydrated ? children : fallback
}

const config = {
  appearance: 'dark',
  theme: {
    container: {
      border: '1px solid oklch(var(--border) / 0.05)',
      borderRadius: '12px',
    },
    shape: {
      borderRadiusSecondary: 8,
    },
    colorSchemes: {
      light: {
        palette: {
          primary: {
            main: '#a7f5d6',
          },
          secondary: {
            main: '#a7f5d6',
          },
        },
      },
      dark: {
        palette: {
          primary: {
            main: '#a7f5d6',
          },
          secondary: {
            main: '#a7f5d6',
          },
          background: {
            paper: '#0f0f12',
            default: '#0f0f12',
          },
        },
      },
    },
  },
} as Partial<WidgetConfig>

export function LifiBridgeWidget() {
  return (
    <ClientOnly fallback={<Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />}>
      <LiFiWidget
        config={{
          ...config,
          chains: {
            allow: SUPPORTED_CHAINS.map((chain) => chain.id),
          },
        }}
        integrator="HypurrFi"
      />
    </ClientOnly>
  )
}
